module.exports = __webpack_public_path__ + "media/img/illustrations/esr-check-32c234ae9d056cb908c97bf01ceba034.svg";